import { useState } from "react";
import clsx from "clsx";
import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import { useGlobalData } from "@/contexts/GlobalData";
interface CopyTextComponentProps extends GeneralPropsType {
  value: string;
  iconSuccess?: React.ReactNode;
  hideTextMessage?: boolean;
}
const CopyTextComponent = ({
  value,
  className,
  iconSuccess,
  children,
  hideTextMessage
}: CopyTextComponentProps) => {
  const {
    translate,
    getIcon,
    hapticFeedback
  } = useGlobalData();
  const [showSuccess, setShowSuccess] = useState(false);
  const CopyTextComponent = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 800);
      hapticFeedback.impactOccurred("light");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  return <div onClick={CopyTextComponent} className={clsx("relative cursor-pointer", className)} data-sentry-component="CopyTextComponent" data-sentry-source-file="index.tsx">
            {children}
            <div className={clsx("flex items-center justify-center gap-1 rounded-lg", styles.successOverlay, {
      "opacity-0": !showSuccess,
      "opacity-100": showSuccess
    })}>
                {iconSuccess ||
      // eslint-disable-next-line @next/next/no-img-element
      <img src={getIcon("copied_check")} alt="" className={styles.defaultSuccessIcon} />}
                {!hideTextMessage && <span className="text-primary inline-block text-[0.8em]">{translate("Copied")}</span>}
            </div>
        </div>;
};
export default CopyTextComponent;